import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import { BankAccountInfo } from '../../../core/data/models/bank.account.info.model';

@Injectable()
export class HealthRefundService extends BaseCrudService<BankAccountInfo> {
  controller = 'HealthRefund';
  getMyBankAccount(idNumber: string) {
    return this.get<BankAccountInfo>({}, `${idNumber}/FinancialInfo`);
  }
}
